import React from "react";
import Swiper from './swiper';
import Swiper2 from './swiper2';
import PartnerBox from "./partnerBox";
import Partner01 from "../../assets/partners/fifa.png";
import Partner02 from "../../assets/partners/FRMF.png";
import Partner03 from "../../assets/partners/afc.png";
import Partner04 from "../../assets/partners/laliga.png";
//SCSS
import "./partners.scss";

const Partners = () => {
  const partners = [Partner01, Partner02, Partner03, Partner04];

  return (
  <div id="partners">
     <div className="partners__wrapper">
        {partners.map((partner, index) => (
          <PartnerBox key={index} partner={partner} />
        ))}
      </div>
    <div className="wrapper">
        <Swiper2/>
    </div>
  </div>
 );
};

export default Partners;
